<template>
  <div class="home-baike" v-if="count > 0">
    <div class="left">
      <div class="title">
        <span class="zh">一村一品</span>
        <span class="en">/Village Product</span>
      </div>
      <div
        class="content"
      >“一村一品”是永辉超市2019年的创新项目，旨在深入原始的乡村田野，挖掘最特色的优质农产品、最地道的传统美食，帮助农村将大地的馈赠和传承的饮食文化带给更多消费者。</div>
      <div class="link" @click="goto('/ovop/list')">
        {{count}} 条一村一品
        <img src="@/assets/index/全部商品2.png" />
      </div>
    </div>
    <div class="right">
      <Prev class="arrow arrow-left" @click="onPrev" />
      <Next class="arrow arrow-right" @click="onNext" />
      <el-carousel
        indicator-position="outside"
        height="250px"
        type="card"
        :autoplay="false"
        arrow="never"
        ref="carousel"
      >
        <MyCarouselItem
          v-for="(item, index) in list.slice(0, 5)"
          :key="index"
          style="width: 500px"
          @click="e => onClick(e, item)"
        >
          <div class="card">
            <div class="image">
              <img :src="util.getImageUrl(util.getHead(util.string2Array(item.images)), '250x250')" />
            </div>
            <div class="intro">
              <div class="title">{{item.name}}</div>
              <div class="content">{{item.features}}</div>
              <!-- <img src="@/assets/index/一村一品底纹.png" /> -->
            </div>
          </div>
        </MyCarouselItem>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import Prev from "./Prev";
import Next from "./Next";
import MyCarouselItem from "./MyCarouselItem";
export default {
  name: "HomeBaike",
  components: {
    Prev,
    Next,
    MyCarouselItem
  },
  props: {
    list: {
      type: Array,
      default: []
    },
    count: Number
  },
  data() {
    return {
      controlIndex: 0,
      currentIndex: 0
    };
  },
  computed: {
    controlSize: function() {
      return this.controlIndex + 4 >= this.list.length ? 4 : 5;
    }
  },
  // watch: {
  //   list: {
  //     deep: true,
  //     handler(newVal, oldVal) {
  //       this.currentList = [...this.list].splice(0, 4);
  //       this.current = this.currentList[0];
  //     }
  //   }
  // },
  methods: {
    onClick(e, item) {
      if (e) {
        this.goto("/ovop/detail/" + item.id, true);
      }
    },
    onPrev() {
      this.$refs["carousel"].prev();
    },
    onNext() {
      this.$refs["carousel"].next();
    },
    goto(path, open) {
      if (open) {
        window.open(path);
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="scss">
.home-baike {
  .el-carousel__indicators--outside {
    margin: 20px;

    .is-active {
      button {
        background-color: rgba(27, 153, 79, 1);
      }
    }
  }
}
</style>

<style lang="less" scoped>
.home-baike {
  width: 1100px;
  margin: 100px auto;

  .arrow {
    position: absolute;
    top: 111px;
  }

  .arrow-left {
    left: -50px;
  }

  .arrow-right {
    right: -50px;
  }

  .left {
    display: inline-block;
    width: 320px;
    margin-right: 200px;
    vertical-align: top;

    .title {
      .zh {
        font-size: 28px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(51, 51, 51, 1);
        line-height: 31px;

        margin-right: 20px;
      }

      .en {
        font-size: 14px;
        font-weight: 200;
        color: rgba(132, 135, 145, 1);
        line-height: 20px;
      }
    }

    .content {
      margin-top: 36px;
      margin-bottom: 36px;
      font-size: 16px;
      font-weight: 200;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }

    .link {
      display: inline-block;
      height: 36px;
      line-height: 36px;
      padding: 0 10px;
      border: 1px solid rgba(132, 135, 145, 0.5);
      font-size: 12px;
      font-weight: 200;
      color: rgba(132, 135, 145, 1);
      cursor: pointer;
      img {
        width: 12px;
        margin-left: 24px;
      }
    }

    .link:hover {
      border: 1px solid rgba(51, 51, 51, 1);
      background: rgba(51, 51, 51, 1);
      color: white;
    }
  }

  .right {
    display: inline-block;
    width: 580px;

    position: absolute;

    .card {
      width: 500px;
      height: 250px;
      background: linear-gradient(
        90deg,
        rgba(98, 98, 98, 1) 0%,
        rgba(16, 16, 16, 1) 100%
      );
      cursor: pointer;

      .image {
        width: 250px;
        height: 250px;

        display: inline-block;
        vertical-align: top;
        opacity: 0.9;
        // filter: alpha(opacity=60);

        background: #f6f6f6;
      }

      .intro {
        width: 250px;
        height: 250px;

        display: inline-block;

        vertical-align: top;
        // opacity: 0.6;

        // opacity: 0.6;
        // filter: alpha(opacity=10);
        position: absolute;

        background-image: url(~/images/一村一品底纹.png);

        .title {
          font-size: 20px;
          font-family: "FZQKBYSJW";
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          line-height: 22px;

          margin: 30px 0 20px 20px;
          z-index: 2;
        }

        .content {
          font-size: 12px;
          font-weight: 200;
          color: rgba(255, 255, 255, 1);
          line-height: 20px;
          margin: 0 20px 0 20px;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;
          overflow: hidden;
          text-overflow: ellipsis;
          z-index: 2;
        }

        image {
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0.9;
          z-index: 1;
        }
      }
    }
  }
}
</style>